import axios from 'axios';
import qs from 'qs';
import router from '../router.js';
import global from './global.js';
import {Message} from 'element-ui';

// let dev = 'http://192.168.10.211/shoes';
let dev = document.location.protocol+'//xy.shuntun.com/shoes';
// let pro = 'http://192.168.10.211/shoes';
let pro = document.location.protocol+'//xy.shuntun.com/shoes';
export const baseURL=process.env.NODE_ENV === 'development'?dev:pro;
const instance = axios.create({
	baseURL: baseURL,
	timeout: 60000,
});

instance.interceptors.response.use((response)=>{
	if (response.data.code == 300 || response.data.code == 302) {
		let cmp = 1046;
		if(global.cmpId&&global.cmpId.cmp>0){
			cmp = global.cmpId.cmp;
		}
		setTimeout(()=>{
			router.push({
				path: '/login',
				query:{
					cmp:cmp,
				}
			})
		},1000)
	} else if (response.data.code == 1) { // 成功
	  return Promise.resolve(response);
	}else {
		Message.error(response.data.msg?response.data.msg:"数据为空");
		return Promise.reject(response.data);
	}
},err=>{
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				err.message = '请求错误(400)';
				break;
			case 401:
				err.message = '未授权，请重新登录(401)';
				break;
			case 403:
				err.message = '拒绝访问(403)';
				break;
			case 404:
				err.message = '请求出错(404)';
				break;
			case 408:
				err.message = '请求超时(408)';
				break;
			case 500:
				err.message = '服务器错误(500)';
				break;
			case 501:
				err.message = '服务未实现(501)';
				break;
			case 502:
				err.message = '网络错误(502)';
				break;
			case 503:
				err.message = '服务不可用(503)';
				break;
			case 504:
				err.message = '网络超时(504)';
				break;
			case 505:
				err.message = 'HTTP版本不受支持(505)';
				break;
			default:
				err.message = `连接出错(${err.response.status})!`;
		}
	} else {
		err.message = '连接服务器失败!'
	}
	Message.error(err.message);
	return Promise.resolve(err);
})

const postForm = (url, data) => {
	if(data==null){
		data = {};
	}
	Object.assign(data,global.cmpId)
	let head  = {'content-type': 'application/x-www-form-urlencoded'};
	head['X-Token'] = localStorage.getItem("token")?localStorage.getItem("token"):"";
	head['agent'] = 'ipad';
	return instance({
		method: 'post',
		url: url,
		data: qs.stringify(data),
		headers: head,
		baseURL:baseURL,
	});
}

/**登陆**/
export const login = (data,cmp) => {
	return postForm("/mobile/login/login", data, cmp);
}
//请求登陆
export const tryLogin = (data) => {
	return postForm("/mobile/login/tryLogin", data);
}
//获得角色权限
export const getRoleLimits = (data) =>{
	return postForm("/mobile/role/getRole", data);
}
//订货统计
export const orderAmountInfo = (data) => {
	return postForm("/mobile/home/orderAmountInfo", data);
}
//应收统计
export const orderNeedpayInfo = (data) => {
	return postForm("/mobile/home/orderNeedpayInfo", data);
}
//发货统计
export const orderSendInfo = (data) => {
	return postForm("/mobile/home/orderSendInfo", data);
}
//库存统计
export const stockInfo = (data) => {
	return postForm("/mobile/home/stockInfo", data);
}

//更改密码
export const updatePass = (data) => {
	return postForm("/mobile/home/updatePass", data);
}
//获得数据
export const getDataStorage = (data)=>{
	return postForm("/emp/system/getDataStorage", data);
}
//设置数据
export const setDataStorage = (data)=>{
	return postForm("/emp/system/setDataStorage",data);
}
//获取客户列表
export const customerlistCustomer = (data) => {
    return postForm("/emp/customer/listCustomer", data);
}
//获取客户类别
export const customergetCustomerClassify = (data) => {
    return postForm("/mobile/customer/getCustomerClassify", data);
}
// 获取客户编号
export const customergetCNumber = (data)=>{
    return postForm("/mobile/customer/getCNumber", data);
}
// 增加客户
export const customeraddCustomer = (data)=>{
    return postForm("/mobile/customer/addCustomer", data);
}
// 启用禁用客户
export const customersetCustomerValid = (data)=>{
    return postForm("/mobile/customer/setCustomerValid", data);
}
// 删除客户
export const customerdeleteCustomer = (data)=>{
    return postForm("/mobile/customer/deleteCustomer", data);
}
// 获取客户详情
export const customercustomerDetail = (data)=>{
    return postForm("/mobile/customer/customerDetail", data);
}
// 修改客户信息
export const customereditCustomer = (data)=>{
    return postForm("/mobile/customer/editCustomer", data);
}
// 修改登录客户信息
export const editLoginCustomer = (data)=>{
    return postForm("/mobile/customer/editLoginCustomer", data);
}
// 修改/补充发票信息
export const customereditCustomerInvoice = (data)=>{
    return postForm("/mobile/customer/editCustomerInvoice", data);
}
// 新增收货信息
export const customeraddCustomerAddress = (data)=>{
    return postForm("/mobile/customer/addCustomerAddress", data);
}
// 获取收货信息
export const customercustomerAddress = (data)=>{
    return postForm("/mobile/customer/customerAddress", data);
}
// 修改收货信息
export const customereditCustomerAddress = (data)=>{
    return postForm("/mobile/customer/editCustomerAddress", data);
}
// 删除收货信息
export const customerdeleteCustomerAddress = (data)=>{
    return postForm("/mobile/customer/deleteCustomerAddress", data);
}
// 设为默认联系人
export const customersetMainContact = (data)=>{
    return postForm("/mobile/customer/setMainContact", data);
}
//客户安装地址新增修改删除
export const customerWorkAddress = (data)=>{
    return postForm("/mobile/customer/customerWorkAddress", data);
}
export const addCustomerWorkAddress = (data)=>{
    return postForm("/mobile/customer/addCustomerWorkAddress", data);
}
export const editCustomerWorkAddress = (data)=>{
    return postForm("/mobile/customer/editCustomerWorkAddress", data);
}
export const deleteCustomerWorkAddress = (data)=>{
    return postForm("/mobile/customer/deleteCustomerWorkAddress", data);
}
//客户状态
export const getCustomerState = (data)=>{
	return postForm("/emp/customer/getCustomerState", data);
}
//财务汇总
export const getSumPayment = (data)=>{
	return postForm("/emp/home/getSumPayment", data);
}
//库存汇总
export const getMonthData = (data)=>{
	return postForm("/emp/home/getMonthData", data);
}
//财务记录
export const listPayment = (data)=>{
    return postForm("/mobile/payment/listCustomerPayment", data);
}
//获取财务类别
export const getPaymentClassify = (data)=>{
    return postForm("/mobile/payment/getPaymentClassify", data);
}
//添加客户帐
export const addCustomerPayment = (data)=>{
    return postForm("/mobile/payment/addCustomerPayment", data);
}
//批量添加客户帐
export const batchAddCustomerPayment = (data)=>{
    return postForm("/mobile/payment/batchAddCustomerPayment", data);
}
//添加财务收入支出
export const addPayment = (data)=>{
    return postForm("/mobile/payment/addPayment", data);
}
//批量添加财务收入支出
export const batchAddPayment = (data)=>{
    return postForm("/mobile/payment/batchAddPayment", data);
}
//取消其他收支
export const cancelOtherPayment = (data)=>{
    return postForm("/mobile/payment/cancelOtherPayment", data);
}
//取消客户收款
export const cancelCustomerPayment = (data)=>{
    return postForm("/mobile/payment/cancelCustomerPayment", data);
}
//获取客户对账单
export const getCustomerPayment = (data)=>{
    return postForm("/mobile/payment/getCustomerPayment", data);
}
//获取其它收入支出单
export const getOtherPayment = (data)=>{
    return postForm("/mobile/payment/listOtherPayment", data);
}
//获取应收记录
export const getNeedPayment = (data)=>{
    return postForm("/mobile/payment/getNeedPayment", data);
}
//冲账
export const balancePayment = (data)=>{
    return postForm("/mobile/payment/balancePayment", data);
}
//预支排行
export const listAdvance = (data)=>{
	return postForm("/emp/payment/listAdvance", data);
}
//员工预支排行
export const empAdvanceStatistic = (data)=>{
	return postForm("/emp/payment/empAdvanceStatistic",data);
}

//发货信息
export const listSend = (data)=>{
    return postForm("/mobile/order/send/listSend", data);
}
export const empListSend = (data)=>{
	return postForm("/emp/order/send/listSend",data);
}
//发货信息详情
export const listSendDetail = (data)=>{
    return postForm("/mobile/order/send/listSendDetail", data);
}
//修改发货信息
export const editSendDetail = (data)=>{
    return postForm("/mobile/order/send/editSendDetail", data);
}
//修改退货信息
export const cancelSendItemUnit = (data)=>{
    return postForm("/mobile/order/send/cancelSendItemUnit", data);
}
//撤销发货详细
export const cancelOrderDetailSend = (data)=>{
    return postForm("/mobile/order/send/cancelOrderDetailSend", data);
}
//获取订单需要发货的产品项
export const getNeedSendOrderDetail = (data)=>{
    return postForm("/mobile/order/send/getNeedSendOrderDetail", data);
}
//获取客户未发货记录
export const getCustomerSendDetail = (data)=>{
    return postForm("/mobile/order/send/getCustomerNotSendOrderDetail", data);
}
//获取产品未发货记录
export const getProductNotSendOrderDetail = (data)=>{
    return postForm("/mobile/order/send/getProductNotSendOrderDetail", data);
}
//新增发货
export const addOrderSend = (data)=>{
    return postForm("/mobile/order/send/addOrderSend", data);
}
//新增产品发货
export const addProductSend = (data)=>{
    return postForm("/mobile/order/send/addProductSend", data);
}
//订单统计-按客户统计
export const orderStatisticByCust = (data)=>{
    return postForm("/mobile/order/orderStatisticByCust", data);
}
//订单统计-按客户统计
export const orderStatisticByCust2 = (data)=>{
    return postForm("/emp/order/orderStatisticByCust", data);
}
//订单统计-按订单销售员统计
export const orderStatisticByEmp = (data)=>{
    return postForm("/mobile/order/orderStatisticByEmp", data);
}
//订单统计-按产品统计
export const orderStatisticByProd = (data)=>{
    return postForm("/mobile/order/orderStatisticByProd", data);
}
export const empOrderStatisticByProd = (data)=>{
    return postForm("/emp/order/orderStatisticByProd", data);
}

//订单统计-订单详情
export const getStatisticDetail = (data)=>{
    return postForm("/emp/order/getStatisticDetail", data);
}


//订单列表
export const getListOrder = (data)=>{
    return postForm("/mobile/order/listOrder", data);
}
//获取订单号
export const ordergetOnumber = (data)=>{
    return postForm("/mobile/order/getOnumber", data);
}
//保存订货单
export const orderaddOrder = (data)=>{
    return postForm("/mobile/order/addOrder", data);
}
//获取订单
export const getOrderDetail = (data)=>{
    return postForm("/mobile/order/orderDetail", data);
}

//修改订单产品项
export const ordereditOrderDetail = (data)=>{
    return postForm("/mobile/order/editOrderDetail", data);
}
//修改订单
export const ordereditOrder = (data)=>{
    return postForm("/mobile/order/editOrder", data);
}
//设置订单状态
export const setOrderState = (data)=>{
    return postForm("/mobile/order/setOrderState", data);
}
// 开启关闭订单项
export const ordersetOrderDetailValid = (data)=>{
    return postForm("/mobile/order/setOrderDetailValid", data);
}

// 获取公司结算账号列表
export const companygetCompanyAccount = (data)=>{
    return postForm("/mobile/company/getCompanyAccount", data);
}
// 获取公司信息
export const getInfo = (data) => {
    return postForm("/mobile/login/company", data);
}
//获取公司基本信息
export const getCompanyBasic = (data) => {
	return postForm('/emp/system/getCompanyBasic',data);
}
//获取产品单位
export const getCustomerProduct = (data)=>{
	return postForm("/mobile/system/getCustomerProduct", data);
}

// 员工列表
export const employeelistEmployee = (data)=>{
    return postForm("/mobile/employee/listEmployee", data);
}
//编辑员工信息
export const editEmployee = (data)=>{
    return postForm("/mobile/employee/editEmployee", data);
}

//获取当前登录员工信息
export const homeGetEmpInfo = (data)=>{
    return postForm("/mobile/login/getLoginUser", data);
}

export const getCustomerRanksSetting = (data)=>{
    return postForm("/mobile/customer/getCustomerRanksSetting", data);
}

//客户出库统计
export const getCustomerStockOutProduct = (data)=>{
	return postForm("/emp/product/getCustomerStockOutProduct", data);
}
//库存明细
export const getProductStock = (data)=>{
    return postForm("/mobile/stock/getProductStock", data);
}
export const empGetProductStock = (data)=>{
    return postForm("/emp/product/getProductStock", data);
}
//仓库列表
export const listWareHouse = (data)=>{
    return postForm("/mobile/stock/listWarehouse", data);
}
//获取商品指定规格库存
export const getSpecStock = (data)=>{
    return postForm("/mobile/stock/getSpecStock", data);
}
// 产品列表plus
export const listProduct = (data)=>{
    return postForm("/emp/product/listProduct", data);
}
// 商品入库
export const addInboundRecord = (data)=>{
    return postForm("/emp/product/addInboundRecord", data);
}
// 商品出库
export const addOutboundRecord = (data)=>{
    return postForm("/emp/product/addOutboundRecord", data);
}
// 库存调拨
export const stockTransfer = (data)=>{
    return postForm("/emp/product/stockTransfer", data);
}
// 出入库明细
export const getCollectionDetails = (data)=>{
    return postForm("/mobile/stock/getCollectionDetails", data);
}
// 出入库汇总
export const sumRecord = (data)=>{
    return postForm("/mobile/stock/sumRecord", data);
}
// 获取待发货出库的订单
export const getWaitSendOrder = (data)=>{
    return postForm("/mobile/stock/getWaitSendOrder", data);
}
//获取订单需要发货的产品项II
export const getNeedSendOrderDetailII = (data)=>{
    return postForm("/mobile/stock/getNeedSendOrderDetail", data);
}
//取消出入库信息
export const cancelScanRecord = (data)=>{
    return postForm("/mobile/stock/cancelScanRecord", data);
}
//修改出入库信息
export const editScanRecord = (data)=>{
    return postForm("/mobile/stock/editScanRecord", data);
}

// 获取列设置
export const getTableCols = (data)=>{
    return postForm("/emp/employee/getTableCols", data);
}
// 修改列设置
export const setTableCols = (data)=>{
    return postForm("/emp/employee/setTableCols", data);
}

// 获取客户数据
export const getCustomerDataStorage = (data)=>{
    return postForm("/mobile/system/getCustomerDataStorage", data);
}
// 设置客户数据
export const setCustomerDataStorage = (data)=>{
    return postForm("/mobile/system/setCustomerDataStorage", data);
}


// 生产计划单
export const listPlan = (data)=>{
    return postForm("/emp/process/listPlan", data);
}

// 计件二维码
export const listQrCode = (data)=>{
    return postForm("/emp/process/listQrCode", data);
}

// 计件扫码记录
export const listQrCodeScanRecord = (data)=>{
    return postForm("/emp/process/listQrCodeScanRecord", data);
}

// 计件扫码统计
export const listQrCodeStaticis = (data)=>{
    return postForm("/emp/process/listQrCodeStaticis", data);
}

// 车间员工合格率看板
export const getQualified = (data)=>{
    return postForm("/emp/process/getQualified", data);
}


// 产品列表
export const productlistProduct = (data)=>{
    return postForm("/mobile/product/getList", data);
}
export const listProductW = (data)=>{
	return postForm("/emp/product/listProductW", data);
}
//获取产品信息
export const productDetail = (data) => {
    return postForm("/mobile/product/productDetail", data);
}
/**获取全局产品,颜色、尺码、标签设置**/
export const getGeneralSetting = (data) => {
    return postForm("/mobile/product/getGeneralSetting", data);
}
// 获取产品类别
export const productgetProdClassify = (data) => {
    return postForm("/mobile/product/getProdClassify", data);
}

//反馈
export const userFeedback = (data) => {
	return postForm("/mobile/feedback/feedback", data);
}
//获取公告类型
export const getLabels = (data) => {
	return postForm("/mobile/notice/getLabels", data);
}

//查看公告详情
export const noticeGetDetail = (data) => {
	return postForm("/mobile/notice/getDetail", data);
}
//获取公告
export const noticeGetNotice = (data) => {
	return postForm("/mobile/notice/getNotice", data);
}

//采购单
export const mListOrder = (data) =>{
	return postForm('/material/order/listOrder',data);
}
//供应商列表
export const listSupply = (data) =>{
	return postForm('/material/supply/listSupply',data);
}
//采购产品
export const mListProduct = (data) =>{
	return postForm('/material/order/listProduct',data);
}
//采购产品2
export const listProductSpecByWare = (data) =>{
	return postForm('/material/order/listProductSpecByWare',data);
}
//采购仓库
export const mListWare = (data) =>{
	return postForm('/material/ware/listWare',data);
}
//生成采购单号码
export const generateNum = (data) =>{
	return postForm('/material/order/generateNum',data);
}
//创建采购订单
export const createOrder = (data) =>{
	return postForm('/material/order/createOrder',data);
}
//编辑采购单
export const mEditOrder = (data) =>{
	return postForm('/material/order/editOrder',data);
}
//采购订单详情
export const mOrderDetail = (data) =>{
	return postForm('/material/order/orderDetail',data);
}
//删除采购单
export const deleteOrder = (data) =>{
	return postForm('/material/order/deleteOrder',data);
}
//编辑采购单
export const editOrderPass = (data) =>{
	return postForm('/material/order/editOrderPass',data);
}
//采购退货单
export const listReturn = (data) =>{
	return postForm('/material/order/listReturn',data);
}
//创建采购退货单
export const createReturn = (data) =>{
	return postForm('/material/order/createReturn',data);
}
//编辑采购退货单
export const editReturn = (data) =>{
	return postForm('/material/order/editReturn',data);
}
//删除采购退货单
export const deleteReturn = (data)=>{
    return postForm("/material/order/deleteReturn", data);
}
//采购出入库明细
export const listRecord = (data)=>{
    return postForm("/material/order/listRecord", data);
}
//删除采购出入库
export const deleteRecord = (data)=>{
    return postForm("/material/order/deleteRecord", data);
}
//采购入库
export const orderInRecord = (data)=>{
	return postForm("/material/order/orderInRecord", data);
}
//领料出库
export const listOutRecord = (data) =>{
	return postForm('/material/order/listOutRecord',data);
}
//删除领料出库
export const deleteOutRecord = (data) =>{
	return postForm('/material/order/deleteOutRecord',data);
}
//编辑领料出库
export const editOutRecord = (data) =>{
	return postForm('/material/order/editOutRecord',data);
}
//新建领料出库
export const createOutRecord = (data) =>{
	return postForm('/material/order/createOutRecord',data);
}
//领料出库详情
export const outRecordDetail = (data) =>{
	return postForm('/material/order/outRecordDetail',data);
}

//编辑材料入库
export const editInRecord = (data) =>{
	return postForm('/material/order/editInRecord',data);
}
//新建材料人库
export const createInRecord = (data) =>{
	return postForm('/material/order/createInRecord',data);
}
//材料入库详情
export const inRecordDetail = (data) =>{
	return postForm('/material/order/inRecordDetail',data);
}
//材料入库
export const listInRecord = (data) =>{
	return postForm('/material/order/listInRecord',data);
}
//删除材料入库
export const deleteInRecord = (data) =>{
	return postForm('/material/order/deleteInRecord',data);
}
//看板
export const panelData = (data) =>{
	return postForm('/panel/panelData',data);
}
export const listProductSpec = (data) =>{
	return postForm('/material/product/listProductSpec',data);
}
//采购金额按供应商统计 
export const getMaterialOrderSumGroupByS = (data) =>{
	return postForm('/material/order/getMaterialOrderSumGroupByS',data);
}
export const listProductSpecStock = (data) =>{
	return postForm('/material/product/listProductSpecStock',data);
}
export const getProductBill = (data)=>{
	return postForm('/emp/bill/getProductBill',data);
}
export const getProductSpecBill = (data)=>{
	return postForm('/emp/bill/getProductSpecBill',data);
}
export const systemgetPrintInfo = (data)=>{
	return postForm('/emp/system/getPrintInfo',data);
}
//BOM清单编辑
export const editBillMenu = (data)=>{
	return postForm('/emp/bill/editBillMenu',data);
}
//考勤统计
export const newGetAttendanceStatistics = (data) => {
	return postForm('/emp/attendance/newGetAttendanceStatistics',data);
}
//考勤统计出勤状态
export const getDailyStatistics = (data) => {
	return postForm('/emp/attendance/getDailyStatistics',data);
}
//考勤参数
export const newGetSalary = () => {
	return postForm('/emp/system/newGetSalary');
}
//货运列表
export const listTransport = (data) => {
	return postForm('/emp/customer/listTransport',data);
}
//微信商城商品列表
export const wxListProduct = (data) =>{
	return postForm('/wxAdmin/listProduct',data);
}
//微信商城销售数量 销售金额 发货数量 发货金额 
export const wxOrderStatistic = (data) =>{
	return postForm('/wxAdmin/wxOrderStatistic',data);
}
//商城商品状态数量
export const wxProductStatistic = (data) =>{
	return postForm('/wxAdmin/wxProductStatistic',data);
}
//订单状态
export const getStateOrder = (data) => {
	return postForm('/emp/home/getStateOrder',data);
}
//客户统计
export const customerStatistic = (data) => {
	return postForm('/emp/customer/customerStatistic',data);
}
//客户每天统计
export const customerStatisticByDate = (data) => {
	return postForm('/emp/customer/customerStatisticByDate',data);
}
//日志操作数图(每日)
export const getLogCountGroupByDate = (data) => {
	return postForm('/tongji/getLogCountGroupByDate',data);
}
//活跃用户数图(每日)
export const getUserCountGroupByDate = (data) => {
	return postForm('/tongji/getUserCountGroupByDate',data);
}
//生产量趋势图(每月)
export const getScanGroupByMonth = (data) => {
	return postForm('/tongji/getScanGroupByMonth',data);
}
//前十条按照地区访问的排名
export const getTopIpProvince = (data) => {
	return postForm('/tongji/getTopIpProvince',data)
}
//当前公司的数据
export const getGeneral = (data) => {
	return postForm('/tongji/getGeneral',data);
}


export const getInfoByPost = function(postarr,callback){
	if(postarr!=null&&postarr.length>0){
		let arr = [];
		postarr.forEach(e => {
			arr.push(postForm(e.str,e.data))
		});
		axios.all(arr).then(axios.spread(function(...res){
			for(let i=0;i<res.length;i++){
				postarr[i].func(res[i])
			}
			callback();
		}),()=>{
			callback();
		});
	}
}
export const getInfoPostSingle = (postname,data) => {
	return postForm(postname, data);
}